import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "../interfaces/App";
import { getPicIndex, uploadImage } from "../services/apiService";
import { IApplicationState } from "../stores/AppStore";
import { IPicture } from "../interfaces/App";
import AppSetup from "../core/AppSetup";
import type { AppDispatch } from "../stores/AppStore";
import { useNavigate, useParams } from "react-router-dom";
import { setSubTitle } from "../stores/AppReducer";

function Pictures(props: {path: string}) {
    const app: IAppState = useSelector((appState: IApplicationState) => appState.app);
    const dispatch = useDispatch<AppDispatch>() ;
    const navigate = useNavigate();
    const param = useParams();
    const what = (param as {what: string}).what?.replace(/:/, "");
    const apiUrl = AppSetup.getUserApiUrl();
    const [cat2Show, setCat2Show] = useState(null as string);
    const [img2Show, mySetImg2Show] = useState(null as IPicture);
    const [slideTime, setSlideTime] = useState(0);
    const picIndex = useRef([] as IPicture[]);
    const timer = useRef(undefined);
    const times = useRef(0);
    const [path, setPath] = useState("");
    const fileUplaod: React.RefObject<HTMLInputElement> = React.createRef();
    
    const setImg2Show = (img: IPicture) => {
        // console.log("setImg2Shoe:", img);
        // if the group will now changed, close image to show 
        if (!img2Show || img?.cat === img2Show?.cat) {
            mySetImg2Show(img);
        }  else {
            mySetImg2Show(null);
        }
    }
    const makeIndex = (): IPicture[] => {
        const idx: any[] = [];
        Object.keys(app.pictures).forEach((cat: string) => {
            app.pictures[cat].pic.forEach((img: IPicture) => idx.push(img));
        });
        return idx;
    }    
    const goTo = (ev: any, dir: "next" | "prev") => {
        if (ev) {
            ev.stopPropagation();
            ev.preventDefault();      
            setSlideTime(0);
            clearTimeout(timer.current);
        }
        if (img2Show) {
            let i = picIndex.current.findIndex((img: IPicture) => img.id === img2Show.id);
            if (dir === "next") {
                i++;
            } else {
                i--
            };
            if (i < 0) {
                i = 0;
            }
            if (i === picIndex.current.length) {
                i = picIndex.current.length - 1;
                setSlideTime(0);
                clearTimeout(timer.current);
            }
            setImg2Show(picIndex.current[i]);
        }
    };
    const forward = () => {
        goTo(undefined, "next");
    }
    
    // useEffect(() => {
    //     console.log("what:", what);
    // }, []);
    useEffect(() => {
        if (app.loggedIn && props.path !== path && times.current++ === 0) {
            // console.log("path:", props.path , path);
            dispatch(setSubTitle("Bilder " + props.path));
            dispatch(getPicIndex(props.path)).then(() => times.current = 0);
            setPath("/pictures/" + props.path);
        }
    }, [props.path]);
    useEffect(() => {
        setCat2Show(what);
    }, [what]);
    useEffect(() => {
        if (Object.keys(app.pictures).length > 0) {
            picIndex.current = makeIndex();
        } else {
            picIndex.current = [];
        }
    }, [app.pictures]);
    useEffect(() => {
        if (slideTime > 0 && img2Show) {
            timer.current = setTimeout(forward, slideTime);
        }
    }, [img2Show, slideTime]);
    useEffect(() => {
        setSlideTime(0);
        goTo(null, "prev");
    }, [app.keys.left]);
    useEffect(() => {
        setSlideTime(0);
        goTo(null, "next");
    }, [app.keys.right]);
    useEffect(() => {
        setSlideTime(0);
        setImg2Show(null);
    }, [app.keys.esc]);

    const handleUploadImage = (ev: any) => {
        ev.preventDefault();
        ev.stopPropagation();
        const file: File = ev.target.files[0];
        dispatch(uploadImage({
                path: 'pictures/Aktuell/Neu',
                file, 
                big: 1200,
                thumb: 300,
                type: "image",
                userId: app.user.id,
            }));
    };
    // const toggleFullScreen = (close?: boolean) => {
    //     if (!document.fullscreenElement && !close) {
    //         document.documentElement.requestFullscreen();
    //     } else if (document.fullscreenElement) {
    //         document.exitFullscreen();
    //     }
    // };
    const renderPictures = (img: IPicture, idx: number): React.JSX.Element => {
        return (
            <div key={"pic_" + idx}>
                <img src={apiUrl + "cloud" + path + "?" + img.thumb}
                    onClick={() => setImg2Show(img)}
                    className="thumbnail"
                />
            </div>
        );
    };
    const renderCategorie = (cat: string, idx: number): React.JSX.Element => {
        const entry = app.pictures[cat];
        return (
            <div key={"cat_" + idx}>
                <div className="categorie" onClick={() => {
                    if (what !== cat) {
                        navigate( path + "/:" + cat);
                    } else if (!cat2Show) {
                        setCat2Show(cat);
                    } else {
                      //  setCat2Show(null);
                    }}} 
                >
                    {entry.name}<span>{entry.desc}</span>
                </div>
                {cat === cat2Show 
                    ? <div  className="picture-categorie">{entry.pic.map(renderPictures)}</div>
                    : <div  className="empty-categorie">{`${entry.pic.length} Bilder`}</div>
                }
            </div>
        )
    };
    const renderImage = () => {
        const url = apiUrl + "cloud" + path + "?" + img2Show.name;
        return (
            <img
                src={url} onClick={(ev: any) => {
                    ev.stopPropagation();
                    setImg2Show(null);
                    // toggleFullScreen();
                }}
                className={'fullScreenImage'}
            />
        );
    }
    const renderPicMenu = () => {
        return (
            <>
                <div 
                    onClick={() => navigate("/pictures/Aktuell/:Neu")}
                    className="gotoOtherGallery"
                >
                    Aktuelles
                </div>
                <div 
                    onClick={() => navigate("/pictures/Aktuell/:AbtFranz")}
                    className="gotoOtherGallery"
                >
                    Hausbau Ostsee
                </div>
                <div 
                    onClick={() => navigate("/pictures/Holzhaus/:Siedlungsbau1927")}
                    className="gotoOtherGallery"
                >
                    Das Holzhaus
                </div>
            </>
        );
    };
    return (app.pictures && img2Show)
    ? (
        <div
            className="showedImage" 
            // onClick={() => {setImg2Show(null); toggleFullScreen(true); }}
        >
            {renderImage()}
            <div className="changePic prev" onClick={(ev: any) => goTo(ev, "prev")}>&lang;</div>
            <div className="changePic next" onClick={(ev: any) => goTo(ev, "next")}>&rang;</div>
            {/* <div className={`play ${slideTime > 0 ? "blink" : ""}`} onClick={(ev: any) => {ev.stopPropagation(); setSlideTime(5000)}}>
                &#9654;
            </div> */}
            {/* <div className="close" onClick={() => {toggleFullScreen(null); setSlideTime(0); clearTimeout(timer.current); } } >&#10005;</div> */}
        </div>
    ) : (
        <div className="picture-index">
            {renderPicMenu()}
            <div className="clear"/>
            {Object.keys(app.pictures).sort((a: any, b: any) => {return app.pictures[b].number - app.pictures[a].number; }).map(renderCategorie)}
            <div>
                <input type="file" ref={fileUplaod} onChange={(ev: any) => handleUploadImage(ev)} className="hidden"/>
                <button  onClick={() => fileUplaod.current.click()} >Upload</button>
            </div>
        </div>
    );
}
export default Pictures;
